
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[url_slug]",
      function () {
        return require("private-next-pages/events/[url_slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[url_slug]"])
      });
    }
  